import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '../../../../../node_modules/@angular/forms';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { VehicleGenericSearchCriteria } from '../vehicle-generic-search/vehicle-generic-search-criteria.model';

@Component({
    selector: 'vehicle-generic-form',
    templateUrl: './vehicle-generic-form.html',
})
export class VehicleGenericForm extends BaseComponent {
    public header = '';
    @Input() searchName = '';
    @Input() searchString = '';
    @Input() isResultsFound = false;
    @Output() onReset = new EventEmitter<void>();
    @Output() onSubmit = new EventEmitter<VehicleGenericSearchCriteria>();
    public form: FormGroup;

    constructor() {
        super();
    }

    public ngOnInit() {
        this.emptyForm();
        this.form.get('searchString').setValue(this.searchString);
        // Search automatically if search string not empty
        // (If no vin found from Omni Search) CC #108928
        if (this.searchString.trim() && !this.isResultsFound) {
            this.submit();
        }
    }

    public reset() {
        this.emptyForm();
        this.onReset.emit();
    }

    public submit() {
        this.trimSearchString();
        this.onSubmit.emit(this.form.value);
    }

    private emptyForm() {
        this.form = this.getEmptyForm();
    }

    private getEmptyForm(): FormGroup {
        return new FormGroup({
            'searchString': new FormControl(''),
            'isExact': new FormControl(true)
        });
    }

    private trimSearchString() {
        const searchStringControl = this.form.get('searchString');
        searchStringControl.setValue(searchStringControl.value.trim());
    }
}
